// Collection of all the content that is used in the slides.
// Array is consumed by a .map and displayed in order by carousel.

import pictureStep1 from '../../assets/HIW_steps_1.jpg';
import pictureStep2 from '../../assets/HIW_steps_2.jpg';
import pictureStep3 from '../../assets/HIW_steps_3.jpg';
import pictureStep4 from '../../assets/HIW_steps_4.jpg';


const slideCollection = [
  {
    slideStepTitle: 'Step 1',
    mainTitle: 'Create Your Account',
    bodyContent: `Complete your account profile online at RealtyMogul.com,
      and share your investing goals with us. The process is quick and simple.`,
    image: pictureStep1,
  },
  {
    slideStepTitle: 'Step 2',
    mainTitle: 'Select Your Investment',
    bodyContent: `Once you join, you have exclusive access to current eligible
      investments and can view past performance. Key investment details are presented
      at a glance – explore opportunities that align with your investment goals.`,
    image: pictureStep2,
  },
  {
    slideStepTitle: 'Step 3',
    mainTitle: 'Invest in Minutes',
    bodyContent: `When you are ready to invest, you can quickly complete your
      transaction online. If you have any questions, you can contact our Investor
      Relations team at (877) 977-2776 or at Investor-Help@RealtyMogul.com.`,
    image: pictureStep3,
  },
  {
    slideStepTitle: 'Step 4',
    mainTitle: 'Track Your Investments',
    bodyContent: `You have full visibility into the performance of your investment
      via the RealtyMogul dashboard. Track your total current invested value and
      distributions. You’ll receive quarterly investment reports and annual tax documents.`,
    image: pictureStep4,
  },
];

export default slideCollection;
